import { render, staticRenderFns } from "./Female.vue?vue&type=template&id=06ea318e&scoped=true&"
import script from "./Female.vue?vue&type=script&lang=js&"
export * from "./Female.vue?vue&type=script&lang=js&"
import style0 from "./Female.vue?vue&type=style&index=0&id=06ea318e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ea318e",
  null
  
)

export default component.exports